// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
@media (min-width: 1024px) {
  :host {
    height: 100%;
  }
}

ion-card {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;
}
@media (max-width: 599px) {
  ion-card {
    height: auto;
    min-height: 80vh;
    overflow: visible;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  ion-card {
    height: auto;
    min-height: 80vh;
    overflow: visible;
  }
}
@media (min-width: 1024px) {
  ion-card {
    display: flex;
    flex-direction: column;
  }
}

.card-header {
  height: 5vh;
  max-height: 5vh;
  min-height: 0 !important;
  display: flex;
  align-items: center;
  padding: var(--spacing-medium) var(--spacing-small) !important;
  color: white !important;
  border-left: 5px solid var(--ion-color-primary);
  background: linear-gradient(90deg, color-mix(in srgb, var(--ion-color-primary) 12%, white), color-mix(in srgb, var(--ion-color-primary) 3%, white)) !important;
}

.header-content {
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
}

.pilot-title {
  font-weight: bold;
  left: var(--spacing-small);
  width: auto;
  color: var(--ion-color-primary) !important;
}
@media (max-width: 599px) {
  .pilot-title {
    font-size: clamp(0.8rem, 1.5vw, 1rem);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .pilot-title {
    font-size: 1.1rem;
  }
}
@media (min-width: 1024px) {
  .pilot-title {
    font-size: 1.2rem;
  }
}

.time-filter {
  position: absolute;
  z-index: 990;
  width: 70%;
  height: 70%;
  right: var(--spacing-small);
  margin-right: var(--spacing-large);
  display: flex;
  align-items: center;
}

.card-content {
  height: 97%;
  padding: 0;
  overflow: hidden;
}
@media (max-width: 599px) {
  .card-content {
    height: auto;
    min-height: 97%;
    overflow: visible;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .card-content {
    height: auto;
    min-height: 97%;
    overflow: visible;
  }
}
@media (min-width: 1024px) {
  .card-content {
    flex: 1;
    min-height: 0;
    height: auto;
  }
}

.pilot-summary-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: var(--spacing-small);
  padding-right: var(--spacing-large);
  overflow-y: auto;
  min-width: 0;
}
@media (max-width: 599px) {
  .pilot-summary-container {
    padding-right: var(--spacing-small);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .pilot-summary-container {
    height: auto;
    overflow-y: auto;
    padding-right: var(--spacing-small);
  }
}
@media (min-width: 1024px) {
  .pilot-summary-container {
    flex: 1;
    min-height: 0;
    flex-direction: row;
    padding: var(--spacing-medium);
    gap: var(--spacing-small);
    align-items: stretch;
    overflow: hidden;
  }
}

/* Chart Section: Operations by Drone */
.chart-section {
  width: 100%;
  min-width: 0;
}
@media (max-width: 599px) {
  .chart-section {
    flex: 0 0 auto;
    max-height: 30vh;
    min-height: 180px;
    margin-bottom: var(--spacing-medium);
    overflow: hidden;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .chart-section {
    flex: 0 0 auto;
    max-height: 30vh;
    min-height: 180px;
    margin-bottom: var(--spacing-medium);
    overflow: hidden;
  }
}
@media (min-width: 1024px) {
  .chart-section {
    min-height: auto;
    height: auto;
    flex: 1.2 1 0;
    width: auto;
    margin-right: 0;
  }
}

/* Info Cards Section: 4 cards layout */
.info-cards-section {
  display: grid;
  gap: var(--spacing-small);
  width: 100%;
  min-width: 0;
}
@media (max-width: 599px) {
  .info-cards-section {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    flex: 0 0 auto;
    min-height: auto;
    margin-bottom: var(--spacing-xs);
    gap: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .info-cards-section {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    flex: 0 0 auto;
    min-height: auto;
    margin-bottom: var(--spacing-xs);
    gap: var(--spacing-medium);
  }
}
@media (min-width: 1024px) {
  .info-cards-section {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-auto-rows: 1fr;
    flex: 1.15 1 0;
    width: auto;
    gap: var(--spacing-xs);
    height: auto;
    margin-right: 0;
  }
}

/* Operations Section: Last Operations */
.operations-section {
  width: 100%;
  display: flex;
  min-width: 0;
  gap: var(--spacing-small);
}
@media (max-width: 599px) {
  .operations-section {
    flex: 0 0 auto;
    min-height: auto;
    margin-bottom: var(--spacing-xs);
    gap: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .operations-section {
    flex: 0 0 auto;
    min-height: auto;
    margin-bottom: var(--spacing-xs);
    gap: var(--spacing-medium);
  }
}
@media (min-width: 1024px) {
  .operations-section {
    flex: 1.2 1 0;
    height: auto;
    width: auto;
  }
}

.chart-container {
  height: 100%;
  width: 100%;
  margin: 0;
}

.top-summary-card {
  height: 50%;
  padding-bottom: var(--spacing-xx-small);
  margin: 0 !important;
}

.bottom-summary-card {
  height: 50%;
  padding-top: var(--spacing-xx-small);
  margin: 0 !important;
}

.card-title-label {
  display: flex;
  align-items: center;
  color: var(--ion-color-primary);
  text-align: center;
  font-weight: 500;
}
@media (max-width: 599px) {
  .card-title-label {
    font-size: clamp(0.7rem, 1.6vmin, 0.85rem);
    line-height: 1.1;
    text-align: center;
    flex: 0 0 auto;
    padding: 0 var(--spacing-xs);
    margin-right: auto;
    margin-left: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .card-title-label {
    font-size: clamp(0.75rem, 1.3vmin, 0.95rem);
  }
}
@media (min-width: 1024px) {
  .card-title-label {
    font-size: clamp(0.85rem, 1.1vmin, 1.1rem);
  }
}

.card-content-label {
  display: flex !important;
  text-align: center;
  flex: 1 !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100%;
  font-weight: 600;
}
@media (max-width: 599px) {
  .card-content-label {
    font-size: clamp(0.6rem, 1.5vmin, 0.75rem);
    line-height: 1;
    justify-content: flex-end !important;
    flex: 0 0 auto !important;
    text-align: right;
    min-width: 0;
    max-width: 45% !important;
    padding: 0 var(--spacing-xs);
    margin-right: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .card-content-label {
    font-size: clamp(0.7rem, 1.3vmin, 0.85rem);
  }
}
@media (min-width: 1024px) {
  .card-content-label {
    font-size: clamp(0.85rem, 1.8vmin, 1.1rem);
  }
}

.info-card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  margin: 0;
  padding: var(--spacing-xs);
  overflow: hidden;
  border-radius: var(--border-radius-small);
  background-color: rgba(0, 0, 0, 0.02);
}
@media (max-width: 599px) {
  .info-card-content {
    padding: var(--spacing-small);
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: auto;
    min-height: 45px;
    gap: var(--spacing-xs);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .info-card-content {
    padding: var(--spacing-small);
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: auto;
    min-height: 45px;
    gap: var(--spacing-xs);
  }
}
@media (min-width: 1024px) {
  .info-card-content {
    padding: var(--spacing-small);
  }
}

.operations-card {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
}
@media (max-width: 599px) {
  .operations-card {
    height: auto;
    min-height: 180px;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .operations-card {
    height: auto;
    min-height: 180px;
  }
}

.operations-list-container {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}
@media (max-width: 599px) {
  .operations-list-container {
    max-height: 24vh;
  }
}

.last-operations-info-label {
  display: block;
  text-align: center;
  color: var(--ion-color-dark);
  --color: var(--ion-color-dark);
  padding: var(--spacing-xs);
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.03);
  min-height: auto;
}
@media (max-width: 599px) {
  .last-operations-info-label {
    font-size: clamp(0.55rem, 1.3vmin, 0.7rem);
    line-height: 1;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .last-operations-info-label {
    font-size: clamp(0.65rem, 1.1vmin, 0.75rem);
  }
}
@media (min-width: 1024px) {
  .last-operations-info-label {
    font-size: clamp(0.7rem, 0.9vmin, 0.8rem);
  }
}
.last-operations-info-label ion-label {
  color: var(--ion-color-dark);
  display: block;
  word-break: break-word;
}

.card-container-no-summary,
.card-container-summary {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
  height: 100%;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.card-container-summary > * {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

ion-col {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
  min-height: 0 !important;
}

ion-grid.general-full-height {
  display: flex !important;
  flex: 1 !important;
  height: 100% !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

ion-col[size="2"] .top-summary-card ion-card, ion-col[size="2"] .bottom-summary-card ion-card {
  flex: 1 !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: flex-start !important;
  align-items: center !important;
}
ion-col[size="2"] .top-summary-card {
  padding-bottom: var(--spacing-xx-small) !important;
}
ion-col[size="2"] .bottom-summary-card {
  padding-top: var(--spacing-xx-small) !important;
}

ion-col[size="4"] {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
ion-col[size="4"] .chart-container {
  width: 100% !important;
  height: 100% !important;
}

.operations-column {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
  max-height: 100% !important;
  flex: 1 !important;
  gap: var(--spacing-medium) !important;
}

.operations-column ion-card {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  margin: 0 !important;
  overflow: hidden !important;
}

.operations-column .card-title-label {
  flex-shrink: 0 !important;
}

.operations-list-container {
  flex: 1 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  min-height: 0 !important;
}

.hidden {
  display: none;
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 800px) or (max-height: 550px) {
  .pilot-title {
    font-size: var(--font-size-large);
  }
  .no-data-label {
    font-size: var(--font-size-medium);
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 800px) and (min-height: 550px) {
  .pilot-title {
    font-size: var(--font-size-large);
  }
  .no-data-label {
    font-size: var(--font-size-medium);
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1000px) and (min-height: 600px) {
  .pilot-title {
    font-size: var(--font-size-xx-large);
  }
  .no-data-label {
    font-size: var(--font-size-medium);
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/log-summaries/pilot-summary/pilot-summary.component.scss","webpack://./src/theme/mocca-breakpoints.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;AADJ;ACqCE;EDrCF;IAIQ,YAAA;EAAN;AACF;;AAGA;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AAAJ;ACUE;EDfF;IAQQ,YAAA;IACA,gBAAA;IACA,iBAAA;EACN;AACF;ACUE;EDtBF;IAcQ,YAAA;IACA,gBAAA;IACA,iBAAA;EAEN;AACF;ACUE;ED7BF;IAoBQ,aAAA;IACA,sBAAA;EAGN;AACF;;AAAA;EACI,WAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,uBAAA;EACA,+CAAA;EACA,8JAAA;AAGJ;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,0BAAA;EACA,WAAA;EACA,0CAAA;AAGJ;ACnCE;ED4BF;IAOQ,qCAAA;EAIN;AACF;ACjCE;EDqBF;IAWQ,iBAAA;EAKN;AACF;AC/BE;EDcF;IAeQ,iBAAA;EAMN;AACF;;AAHA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;AAMJ;;AAHA;EACI,WAAA;EACA,UAAA;EACA,gBAAA;AAMJ;ACnEE;ED0DF;IAMQ,YAAA;IACA,eAAA;IACA,iBAAA;EAON;AACF;ACnEE;EDmDF;IAYQ,YAAA;IACA,eAAA;IACA,iBAAA;EAQN;AACF;ACnEE;ED4CF;IAkBQ,OAAA;IACA,aAAA;IACA,YAAA;EASN;AACF;;AANA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;EACA,mCAAA;EACA,gBAAA;EACA,YAAA;AASJ;ACrGE;EDkFF;IAaQ,mCAAA;EAUN;AACF;ACnGE;ED2EF;IAiBQ,YAAA;IACA,gBAAA;IACA,mCAAA;EAWN;AACF;ACnGE;EDoEF;IAuBQ,OAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,yBAAA;IACA,oBAAA;IACA,gBAAA;EAYN;AACF;;AATA,uCAAA;AACA;EACI,WAAA;EACA,YAAA;AAYJ;AClIE;EDoHF;IAKQ,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,oCAAA;IACA,gBAAA;EAaN;AACF;ACpIE;ED6GF;IAaQ,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,oCAAA;IACA,gBAAA;EAcN;AACF;ACtIE;EDsGF;IAqBQ,gBAAA;IACA,YAAA;IACA,aAAA;IACA,WAAA;IACA,eAAA;EAeN;AACF;;AAZA,uCAAA;AACA;EACI,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAeJ;ACrKE;EDkJF;IAOQ,0BAAA;IACA,oBAAA;IACA,cAAA;IACA,gBAAA;IACA,gCAAA;IACA,0BAAA;EAgBN;AACF;ACxKE;ED2IF;IAgBQ,0BAAA;IACA,oBAAA;IACA,cAAA;IACA,gBAAA;IACA,gCAAA;IACA,0BAAA;EAiBN;AACF;AC3KE;EDoIF;IAyBQ,8BAAA;IACA,2BAAA;IACA,mBAAA;IACA,cAAA;IACA,WAAA;IACA,sBAAA;IACA,YAAA;IACA,eAAA;EAkBN;AACF;;AAfA,wCAAA;AACA;EACI,WAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;AAkBJ;AC7ME;EDuLF;IAOQ,cAAA;IACA,gBAAA;IACA,gCAAA;IACA,0BAAA;EAmBN;AACF;AC9ME;EDgLF;IAcQ,cAAA;IACA,gBAAA;IACA,gCAAA;IACA,0BAAA;EAoBN;AACF;AC/ME;EDyKF;IAqBQ,aAAA;IACA,YAAA;IACA,WAAA;EAqBN;AACF;;AAlBA;EACI,YAAA;EACA,WAAA;EACA,SAAA;AAqBJ;;AAlBA;EACI,WAAA;EACA,uCAAA;EACA,oBAAA;AAqBJ;;AAlBA;EACI,WAAA;EACA,oCAAA;EACA,oBAAA;AAqBJ;;AAlBA;EACI,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AAqBJ;AC9PE;EDoOF;IAQQ,0CAAA;IACA,gBAAA;IACA,kBAAA;IACA,cAAA;IACA,4BAAA;IACA,kBAAA;IACA,kCAAA;EAsBN;AACF;AClQE;ED6NF;IAkBQ,2CAAA;EAuBN;AACF;AChQE;EDsNF;IAsBQ,0CAAA;EAwBN;AACF;;AArBA;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;AAwBF;AC7RE;ED8PF;IAUI,0CAAA;IACA,cAAA;IACA,oCAAA;IACA,yBAAA;IACA,iBAAA;IACA,YAAA;IACA,yBAAA;IACA,4BAAA;IACA,mCAAA;EAyBF;AACF;ACnSE;EDuPF;IAsBI,0CAAA;EA0BF;AACF;ACjSE;EDgPF;IA0BI,0CAAA;EA2BF;AACF;;AAxBA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,yCAAA;EACA,qCAAA;AA2BJ;AChUE;ED4RF;IAYQ,6BAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;EA4BN;AACF;ACpUE;EDqRF;IAsBQ,6BAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;EA6BN;AACF;ACxUE;ED8QF;IAgCQ,6BAAA;EA8BN;AACF;;AA3BA;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AA8BJ;AClWE;EDgUF;IAOQ,YAAA;IACA,iBAAA;EA+BN;AACF;ACjWE;EDyTF;IAYQ,YAAA;IACA,iBAAA;EAgCN;AACF;;AA7BA;EACI,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAgCJ;ACtXE;EDiVF;IAQQ,gBAAA;EAiCN;AACF;;AA9BA;EACI,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;AAiCJ;ACtYE;ED6VF;IAWQ,0CAAA;IACA,cAAA;EAkCN;AACF;ACrYE;EDsVF;IAgBQ,2CAAA;EAmCN;AACF;ACnYE;ED+UF;IAoBQ,yCAAA;EAoCN;AACF;AAlCI;EACE,4BAAA;EACA,cAAA;EACA,sBAAA;AAoCN;;AAhCA;;EAEI,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAmCJ;;AAhCA;EACI,WAAA;EACA,eAAA;EACA,YAAA;AAmCJ;;AAhCA;EACI,wBAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;AAmCJ;;AAhCA;EACI,wBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;AAmCJ;;AA9BM;EACE,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,iCAAA;EACA,sCAAA;EACA,8BAAA;AAiCR;AA7BI;EACE,kDAAA;AA+BN;AA5BI;EACE,+CAAA;AA8BN;;AA1BA;EACI,wBAAA;EACA,8BAAA;EACA,kCAAA;AA6BJ;AA3BI;EACE,sBAAA;EACA,uBAAA;AA6BN;;AAzBA;EACI,wBAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;EACA,qCAAA;AA4BJ;;AAzBA;EACI,uBAAA;EACA,wBAAA;EACA,iCAAA;EACA,oBAAA;EACA,2BAAA;AA4BJ;;AAzBA;EACI,yBAAA;AA4BJ;;AAzBA;EACI,kBAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;AA4BJ;;AAzBA;EACI,aAAA;AA4BJ;;AAzBA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AACA;EAEE;IACI,iCAAA;EAyBN;EAtBE;IACI,kCAAA;EAwBN;AACF;AArBA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EAEE;IACI,iCAAA;EAoBN;EAjBE;IACI,kCAAA;EAmBN;AACF;AAhBA,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EAEE;IACI,oCAAA;EAeN;EAZE;IACI,kCAAA;EAcN;AACF;AAXA,4BAAA","sourcesContent":["@use 'src/theme/mocca-breakpoints' as bp;\r\n\r\n:host {\r\n    display: block;\r\n\r\n    @include bp.desktop {\r\n        height: 100%;\r\n    }\r\n}\r\n\r\nion-card {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n\r\n    @include bp.mobile {\r\n        height: auto;\r\n        min-height: 80vh;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        min-height: 80vh;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n}\r\n\r\n.card-header {\r\n    height: 5vh;\r\n    max-height: 5vh;\r\n    min-height: 0 !important;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: var(--spacing-medium) var(--spacing-small) !important;\r\n    color: white !important;\r\n    border-left: 5px solid var(--ion-color-primary);\r\n    background: linear-gradient(90deg, color-mix(in srgb, var(--ion-color-primary) 12%, white), color-mix(in srgb, var(--ion-color-primary) 3%, white)) !important;\r\n}\r\n\r\n.header-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-small);\r\n}\r\n\r\n.pilot-title {\r\n    font-weight: bold;\r\n    left: var(--spacing-small);\r\n    width: auto;\r\n    color: var(--ion-color-primary) !important;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.8rem, 1.5vw, 1rem);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: 1.1rem;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: 1.2rem;\r\n    }\r\n}\r\n\r\n.time-filter {\r\n    position: absolute;\r\n    z-index: 990;\r\n    width: 70%;\r\n    height: 70%;\r\n    right: var(--spacing-small);\r\n    margin-right: var(--spacing-large);\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.card-content {\r\n    height: 97%;\r\n    padding: 0;\r\n    overflow: hidden;\r\n\r\n    @include bp.mobile {\r\n        height: auto;\r\n        min-height: 97%;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        min-height: 97%;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        flex: 1;\r\n        min-height: 0;\r\n        height: auto;\r\n    }\r\n}\r\n\r\n.pilot-summary-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n    padding: var(--spacing-small);\r\n    padding-right: var(--spacing-large);\r\n    overflow-y: auto;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        padding-right: var(--spacing-small);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        overflow-y: auto;\r\n        padding-right: var(--spacing-small);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        flex: 1;\r\n        min-height: 0;\r\n        flex-direction: row;\r\n        padding: var(--spacing-medium);\r\n        gap: var(--spacing-small);\r\n        align-items: stretch;\r\n        overflow: hidden;\r\n    }\r\n}\r\n\r\n/* Chart Section: Operations by Drone */\r\n.chart-section {\r\n    width: 100%;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        flex: 0 0 auto;\r\n        max-height: 30vh;\r\n        min-height: 180px;\r\n        margin-bottom: var(--spacing-medium);\r\n        overflow: hidden;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        flex: 0 0 auto;\r\n        max-height: 30vh;\r\n        min-height: 180px;\r\n        margin-bottom: var(--spacing-medium);\r\n        overflow: hidden;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        min-height: auto;\r\n        height: auto;\r\n        flex: 1.2 1 0;\r\n        width: auto;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n/* Info Cards Section: 4 cards layout */\r\n.info-cards-section {\r\n    display: grid;\r\n    gap: var(--spacing-small);\r\n    width: 100%;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        grid-template-columns: 1fr;\r\n        grid-auto-rows: auto;\r\n        flex: 0 0 auto;\r\n        min-height: auto;\r\n        margin-bottom: var(--spacing-xs);\r\n        gap: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        grid-template-columns: 1fr;\r\n        grid-auto-rows: auto;\r\n        flex: 0 0 auto;\r\n        min-height: auto;\r\n        margin-bottom: var(--spacing-xs);\r\n        gap: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        grid-template-columns: 1fr 1fr;\r\n        grid-template-rows: 1fr 1fr;\r\n        grid-auto-rows: 1fr;\r\n        flex: 1.15 1 0;\r\n        width: auto;\r\n        gap: var(--spacing-xs);\r\n        height: auto;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n/* Operations Section: Last Operations */\r\n.operations-section {\r\n    width: 100%;\r\n    display: flex;\r\n    min-width: 0;\r\n    gap: var(--spacing-small);\r\n\r\n    @include bp.mobile {\r\n        flex: 0 0 auto;\r\n        min-height: auto;\r\n        margin-bottom: var(--spacing-xs);\r\n        gap: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        flex: 0 0 auto;\r\n        min-height: auto;\r\n        margin-bottom: var(--spacing-xs);\r\n        gap: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        flex: 1.2 1 0;\r\n        height: auto;\r\n        width: auto;\r\n    }\r\n}\r\n\r\n.chart-container {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0;\r\n}\r\n\r\n.top-summary-card {\r\n    height: 50%;\r\n    padding-bottom: var(--spacing-xx-small);\r\n    margin: 0 !important;\r\n}\r\n\r\n.bottom-summary-card {\r\n    height: 50%;\r\n    padding-top: var(--spacing-xx-small);\r\n    margin: 0 !important;\r\n}\r\n\r\n.card-title-label {\r\n    display: flex;\r\n    align-items: center;\r\n    color: var(--ion-color-primary);\r\n    text-align: center;\r\n    font-weight: 500;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.7rem, 1.6vmin, 0.85rem);\r\n        line-height: 1.1;\r\n        text-align: center;\r\n        flex: 0 0 auto;\r\n        padding: 0 var(--spacing-xs);\r\n        margin-right: auto;\r\n        margin-left: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.75rem, 1.3vmin, 0.95rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.85rem, 1.1vmin, 1.1rem);\r\n    }\r\n}\r\n\r\n.card-content-label {\r\n  display: flex !important;\r\n  text-align: center;\r\n  flex: 1 !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  width: 100%;\r\n  font-weight: 600;\r\n\r\n  @include bp.mobile {\r\n    font-size: clamp(0.6rem, 1.5vmin, 0.75rem);\r\n    line-height: 1;\r\n    justify-content: flex-end !important;\r\n    flex: 0 0 auto !important;\r\n    text-align: right;\r\n    min-width: 0;\r\n    max-width: 45% !important;\r\n    padding: 0 var(--spacing-xs);\r\n    margin-right: var(--spacing-medium);\r\n  }\r\n\r\n  @include bp.tablet {\r\n    font-size: clamp(0.7rem, 1.3vmin, 0.85rem);\r\n  }\r\n\r\n  @include bp.desktop {\r\n    font-size: clamp(0.85rem, 1.8vmin, 1.1rem);\r\n  }\r\n}\r\n\r\n.info-card-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: var(--spacing-xs);\r\n    overflow: hidden;\r\n    border-radius: var(--border-radius-small);\r\n    background-color: rgba(0, 0, 0, 0.02);\r\n\r\n    @include bp.mobile {\r\n        padding: var(--spacing-small);\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: auto;\r\n        min-height: 45px;\r\n        gap: var(--spacing-xs);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        padding: var(--spacing-small);\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: auto;\r\n        min-height: 45px;\r\n        gap: var(--spacing-xs);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        padding: var(--spacing-small);\r\n    }\r\n}\r\n\r\n.operations-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    height: 100%;\r\n\r\n    @include bp.mobile {\r\n        height: auto;\r\n        min-height: 180px;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        min-height: 180px;\r\n    }\r\n}\r\n\r\n.operations-list-container {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: var(--spacing-xs);\r\n\r\n    @include bp.mobile {\r\n        max-height: 24vh;\r\n    }\r\n}\r\n\r\n.last-operations-info-label {\r\n    display: block;\r\n    text-align: center;\r\n    color: var(--ion-color-dark);\r\n    --color: var(--ion-color-dark);\r\n    padding: var(--spacing-xs);\r\n    border-radius: 4px;\r\n    background-color: rgba(0, 0, 0, 0.03);\r\n    min-height: auto;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.55rem, 1.3vmin, 0.7rem);\r\n        line-height: 1;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.65rem, 1.1vmin, 0.75rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.7rem, 0.9vmin, 0.8rem);\r\n    }\r\n\r\n    ion-label {\r\n      color: var(--ion-color-dark);\r\n      display: block;\r\n      word-break: break-word;\r\n    }\r\n}\r\n\r\n.card-container-no-summary,\r\n.card-container-summary {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center !important;\r\n    align-items: center !important;\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.card-container-summary > * {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n}\r\n\r\nion-col {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    height: 100% !important;\r\n    overflow: hidden !important;\r\n    min-height: 0 !important;\r\n}\r\n\r\nion-grid.general-full-height {\r\n    display: flex !important;\r\n    flex: 1 !important;\r\n    height: 100% !important;\r\n    min-height: 0 !important;\r\n    overflow: hidden !important;\r\n}\r\n\r\nion-col[size=\"2\"] {\r\n    .top-summary-card, .bottom-summary-card {\r\n      ion-card {\r\n        flex: 1 !important;\r\n        margin: 0 !important;\r\n        display: flex !important;\r\n        flex-direction: column !important;\r\n        justify-content: flex-start !important;\r\n        align-items: center !important;\r\n      }\r\n    }\r\n\r\n    .top-summary-card {\r\n      padding-bottom: var(--spacing-xx-small) !important;\r\n    }\r\n\r\n    .bottom-summary-card {\r\n      padding-top: var(--spacing-xx-small) !important;\r\n    }\r\n}\r\n\r\nion-col[size=\"4\"] {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n\r\n    .chart-container {\r\n      width: 100% !important;\r\n      height: 100% !important;\r\n    }\r\n}\r\n\r\n.operations-column {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    height: 100% !important;\r\n    overflow: hidden !important;\r\n    max-height: 100% !important;\r\n    flex: 1 !important;\r\n    gap: var(--spacing-medium) !important;\r\n  }\r\n\r\n.operations-column ion-card {\r\n    height: 100% !important;\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    margin: 0 !important;\r\n    overflow: hidden !important;\r\n  }\r\n\r\n.operations-column .card-title-label {\r\n    flex-shrink: 0 !important;\r\n  }\r\n\r\n.operations-list-container {\r\n    flex: 1 !important;\r\n    overflow-y: auto !important;\r\n    overflow-x: hidden !important;\r\n    min-height: 0 !important;\r\n  }\r\n\r\n.hidden {\r\n    display: none;\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 800px) or (max-height: 550px) {\r\n\r\n    .pilot-title {\r\n        font-size: var(--font-size-large);\r\n    }\r\n\r\n    .no-data-label {\r\n        font-size: var(--font-size-medium);\r\n    }\r\n\r\n  }\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 800px) and (min-height: 550px) {\r\n\r\n    .pilot-title {\r\n        font-size: var(--font-size-large);\r\n    }\r\n\r\n    .no-data-label {\r\n        font-size: var(--font-size-medium);\r\n    }\r\n  }\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1000px) and (min-height: 600px) {\r\n\r\n    .pilot-title {\r\n        font-size: var(--font-size-xx-large);\r\n    }\r\n\r\n    .no-data-label {\r\n        font-size: var(--font-size-medium);\r\n    }\r\n  }\r\n\r\n/*#endregion Larger Screens*/\r\n\r\n","// =============================================================================\r\n//  accord-breakpoints.scss\r\n//\r\n//  Standard 3-tier Responsive Breakpoints for the Accord Design System.\r\n//  Based on Google Material Design 3 guidelines.\r\n//\r\n//  Breakpoints:\r\n//    Mobile  — max-width: 599px\r\n//    Tablet  — min-width: 600px and max-width: 1023px\r\n//    Desktop — min-width: 1024px\r\n//\r\n//  Usage in component SCSS (with @use):\r\n//    @use 'src/theme/mocca-breakpoints' as bp;\r\n//    @include bp.mobile  { ... }\r\n//    @include bp.tablet  { ... }\r\n//    @include bp.desktop { ... }\r\n//\r\n//  Or via raw @media (legacy/global):\r\n//    @media (max-width: 599px)                        { ... }  // mobile\r\n//    @media (min-width: 600px) and (max-width: 1023px){ ... }  // tablet\r\n//    @media (min-width: 1024px)                       { ... }  // desktop\r\n// =============================================================================\r\n\r\n/// Mobile only — screens ≤ 599px\r\n@mixin mobile {\r\n  @media (max-width: 599px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet only — screens 600px–1023px\r\n@mixin tablet {\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and above — screens ≥ 1024px\r\n@mixin desktop {\r\n  @media (min-width: 1024px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet and above — screens ≥ 600px (tablet + desktop)\r\n@mixin tablet-up {\r\n  @media (min-width: 600px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and below — screens ≤ 1023px (mobile + tablet)\r\n@mixin desktop-down {\r\n  @media (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
